import React from 'react';

const IconlyCurvedBoldAddUser = ({ width = 25, height = 24, fill = "#F04F4F" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 25 24"
  >
    <path
      fill={fill}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.572 13.359C7.468 13.359 4 15.608 4 18.27c0 3.036 4.321 3.387 7.572 3.387 1.873 0 7.572 0 7.572-3.407 0-2.652-3.468-4.891-7.572-4.891Zm-.032-2.294h.032a5.038 5.038 0 0 0 5.033-5.033A5.037 5.037 0 0 0 11.572 1a5.038 5.038 0 0 0-5.033 5.03 5.023 5.023 0 0 0 5 5.035Zm11.288-2.332H21.53V7.478a.75.75 0 0 0-1.5 0v1.255h-1.293a.75.75 0 0 0 0 1.5h1.293v1.255a.75.75 0 0 0 1.5 0v-1.255h1.297a.75.75 0 0 0 0-1.5Z"
    />
  </svg>
);

export default IconlyCurvedBoldAddUser;